<script setup lang="ts">
  import { computed, type PropType } from 'vue';
  import type { Section } from '@storefront/types';

  const props = defineProps({
    sections: { type: Array as PropType<Section[]>, required: false, default: [] },
    placement: { type: String, required: false, default: 'main' },
  });

  const sections = computed(() => {
    return props.sections.filter((section) => {
      return section.placement === props.placement;
    });
  });
</script>
<template>
  <div v-if="sections.length > 0" class="sections-wrapper">
    <template v-for="section in sections" :key="section.id">
      <component :is="section.type" v-bind="section" />
    </template>
  </div>
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  :root {
    --sf-section-renderer-gap: 2rem;

    @include media.query(lg) {
      --sf-section-renderer-gap: 1rem;
    }
  }

  .sections-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--sf-section-renderer-gap);
  }
</style>
